export default __webpack_public_path__ + "static/media/Software.3278b818.svg";